/* eslint-disable */
import store from '@/store/index'
import Vue from 'vue'
import MainService from './MainService'

class Categories {
  async activeCategory (category:any) {
    if (!category || !category.uuid) {
      return false
    }

    const data = {
      route: `ocular/widget/categories/${category.uuid}/active`,
      params: {}
    }

    return MainService.get(data)
      .then((response) => {
        const res = response.data
        if (res.statusCode === 0) {
          store.state.categorySettings.call = res.data.call
          store.state.categorySettings.calendar = res.data.calendar
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

Vue.prototype.$categories = new Categories()
